export default {
  typography: {
    fontFamily: [`Antic Slab`].join(`,`),
    h1: {
      fontFamily: [`Neucha`].join(`,`),
    },
  },
}
